export default "__VITE_ASSET__DR6QVaGW__"